<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'gestoesDeAulas.planosInfantil' })"
            :id="'btn-voltar-planos'"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Plano Semestral Infantil
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn
          depressed
          color="primary"
          @click="() => [visualizarPdf(plano.id), (dialogPdf = true)]"
          :id="'btn-visualizar-pdf'"
        >
          Visualizar Pdf
          <v-icon small right> mdi-note </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="10" md="12" lg="12">
        <v-card>
          <v-card-text>
            <label for="">Professor</label>
            <v-input :id="'input-professor'">
              {{
                plano.gestao_de_aula
                  ? plano.gestao_de_aula.professor
                    ? plano.gestao_de_aula.professor.nome
                    : "- - -"
                  : "- - - "
              }}
            </v-input>

            <label for="">Turma</label>
            <v-input :id="'input-turma'">
              {{
                plano.gestao_de_aula
                  ? plano.gestao_de_aula.turma
                    ? plano.gestao_de_aula.turma.descricao
                    : "- - -"
                  : "- - - "
              }}
            </v-input>

            <label for="">Disciplina</label>
            <v-input :id="'input-disciplina'">
              {{
                plano.gestao_de_aula
                  ? plano.gestao_de_aula.disciplina
                    ? plano.gestao_de_aula.disciplina.descricao
                    : "- - - "
                  : "- - - "
              }}
            </v-input>

            <label for="">Semestre de Referência</label>
            <v-input :id="'input-semestre-referencia'">
              <v-chip>
                {{ plano.semestre?.descricao ?? "- - - " }}
              </v-chip>
            </v-input>

            <label for="">Data lançamento</label>
            <v-input :id="'input-data-lancamento'">
              <v-chip>
                {{
                  plano.created_at
                    ? plano.created_at.substr(0, 10).split("-").reverse().join("/")
                    : "- - - "
                }}
              </v-chip>
            </v-input>

            <label for="">Ultima atualização</label>
            <v-input :id="'input-ultima-atualizacao'">
              <v-chip>
                {{
                  plano.updated_at
                    ? plano.updated_at.substr(0, 10).split("-").reverse().join("/")
                    : "- - - "
                }}
              </v-chip>
            </v-input>
            <v-combobox
              v-model="seriesSelecionadas"
              chips
              label="Series"
              multiple
              readonly
              :id="'combobox-series'"
            />
          </v-card-text>
        </v-card>

        <v-card class="mt-5">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4">
                <label for="">Status</label>
                <e-situacao-plano-infantil
                  :plano="plano"
                  v-on:update="listarPlano"
                  :id="'situacao-plano'"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col :id="'col-objetivos-aprendizagem'">
                <v-divider></v-divider>
                <label>Objetivos de aprendizagem e desenvolvimento </label>
                <v-list-item v-for="(objetivo, i) in objetivosSelecionados" :key="i">
                  <li>
                    {{ objetivo ? objetivo.descricao : "- - -" }}
                  </li>
                </v-list-item>
              </v-col>
            </v-row>

            <v-row>
              <v-col :id="'col-campos-experiencia'">
                <v-divider></v-divider>
                <label>Campos de experiência </label>
                <v-list-item v-for="(experiencia, i) in experienciasSelecionadas" :key="i">
                  <li>
                    {{ experiencia ? experiencia : "- - -" }}
                  </li>
                </v-list-item>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">EIXOS TEMÁTICOS</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.eixos_tematicos ? plano.eixos_tematicos : '- - - '"
                  :id="'textarea-eixos-tematicos'"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label for="">DIREITOS DE APRENDIZAGEM</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.direitos_aprendizagem ? plano.direitos_aprendizagem : '- - - '"
                  :id="'textarea-direitos-aprendizagem'"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">METODOLOGIA, RECURSOS E AVALIAÇÃO</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="
                    plano.metodologia_recursos_avaliacao
                      ? plano.metodologia_recursos_avaliacao
                      : '- - -'
                  "
                  :id="'textarea-metodologia-recursos-avaliacao'"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <EModalVisualizarPDF :dialog="dialogPdf" :pdf="pdf" v-on:update="fecharModal" />
  </main-template>
</template>

<script>
import EModalVisualizarPDF from "@/components/EModalVisualizarPDF.vue";

export default {
  components: {
    EModalVisualizarPDF,
  },
  data() {
    return {
      dialogPdf: false,
      pdf: null,
      showSnackbar: false,
      plano: {},
      plano_id: null,
      seriesSelecionadas: [],
      experienciasSelecionadas: [],
      objetivosSelecionados: [],
      recursosSelecionados: [],
      duvidasSelecionadas: [],
    };
  },
  async mounted() {
    this.getId();
    this.listarPlano(this.pageNumber);
  },
  methods: {
    async getId() {
      const { id } = this.$route.params;
      this.plano_id = id;
    },
    async listarPlano() {
      this.$loaderService.open("Carregando Plano");
      try {
        const { data } = await this.$services.planosService.showSemestralInfantil(this.plano_id);

        this.plano = { ...data.planoSemestralInfantil };
        this.seriesSelecionadas = this.plano.gestao_de_aula.turma.series.map((s) => s.descricao);

        this.objetivosSelecionados = [...data.objeto_aprendizagem];
        this.experienciasSelecionadas = [...data.planoSemestralInfantil.experiencia];
      } catch (error) {
        this.$loaderService.close();
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async carregarDadosAoAtualizarStatus() {
      try {
        this.listarPlano();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async visualizarPdf(planoId) {
      this.pdf = await this.$services.planosService.pdfSemestralInfantil(planoId);
    },
    fecharModal() {
      this.pdf = null;
      this.dialogPdf = false;
    },
  },
};
</script>

<style></style>
